import React, { useEffect, useRef, useState } from 'react';
import * as S from './styles';
import plus from '../../../assets/icons/plus.png';
import { BodyG, BodyM, TaglineG, TaglineM, TaglineP } from '../../../styles/stylesTypography';
import { theme } from '../../../styles/theme';
import api from '../../../services/api';
import Modal from "../../../components/modal/modalGenericV2";
import ModalBlock from "../../../components/modal/modalFuncaoBloqueadaImpressaoFe";
import InputV3 from '../../input/novo/input_v3';
import { store } from 'react-notifications-component';
import RegisterAgronomist from '../../AddModals/RegisterAgronomist';
import RegisterFarm from '../../AddModals/RegisterFarm';
import RegisterProducer from '../../AddModals/RegisterProducer';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import ModalCreateOrEditEvent from '../../modalCreateOrEditEvent';
import IconSearchNotFound from "../../../assets/icons/icons8-search-notfound.png";
import { isTotvs } from '../../../services/globalFunctions';

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
const FarmCropManagement = ({ farmId }) => {
  const [events, setEvents] = useState([]);
  const [selectedCulture, setSelectedCulture] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [showNewEvent, setShowNewEvent] = useState(false);
  const [openModalTrue, setOpenModalTrue] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [agroFarmIdToSelect, setAgroFarmIdToSelect] = useState(null);
  const [titleDrawer, setTitleDrawer] = useState("");
  const [descriptionDrawer, setDescriptionDrawer] = useState("");
  const [agronomistDrawer, setAgronomistDrawer] = useState({ value: null, label: "" });
  const [producerDrawer, setProducerDrawer] = useState({ value: null, label: "" });
  const [agroFarmsDrawer, setAgroFarmsDrawer] = useState({ value: null, label: "" });
  const [cultureDrawer, setCultureDrawer] = useState({ value: null, label: "" });
  const [statusDrawer, setStatusDrawer] = useState({ value: null, label: "" });
  const [startDateDrawer, setStartDateDrawer] = useState("");
  const [endDateDrawer, setEndDateDrawer] = useState("");
  const [agronomists, setAgronomists] = useState([]);
  const [producers, setProducers] = useState([]);
  const [cultures, setCultures] = useState([]);
  const [agroFarms, setAgroFarms] = useState([]);
  const [isFarmDisabled, setIsFarmDisabled] = useState(true);
  const [titleError, setTitleError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [agronomistError, setAgronomistError] = useState(false);
  const [producerError, setProducerError] = useState(false);
  const [farmError, setFarmError] = useState(false);
  const [cultureError, setCultureError] = useState(false);
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [statusError, setStatusError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showAddAgronomist, setShowAddAgronomist] = useState(false);
  const [showAddProducer, setShowAddProducer] = useState(false);
  const [showAddFarm, setShowAddFarm] = useState(false);
  const [idProducer, setIdProducer] = useState(0);
  const [culturesOptions, setCulturesOptions] = useState([]);
  const [talhoesOptions, setTalhoesOptions] = useState([]);
  const [selectedTalhao, setSelectedTalhao] = useState("");
  const [farmDetail, setFarmDetail] = useState(null);
  const [userCoords, setUserCoords] = useState(null);
  const [eventCoords, setEventCoords] = useState(null);

  const location = useLocation();

  const getUserFromStorage = () => {
    try {
      return JSON.parse(localStorage.getItem("@userinfo") || "null");
    } catch (_) {
      return null;
    }
  };

  const isCreateEventBlocked = () => {
    const user = getUserFromStorage();
    const planId = user?.contrato?.agro_plan_config?.agro_plan_id;
    const diasRestante = Number(user?.contrato?.dias_restante ?? 0);
    // 5 = plano com Caderno de Campo nativo; 9/10/11 = Protheus/SIAC/Omie
    // (integrações TOTVS/Omie) - também liberados pra criar evento.
    const planosComCadernoCampo = [5, 9, 10, 11];

    return !planosComCadernoCampo.includes(planId) || (planId === 1 && diasRestante > 0);
  };

  const handleCreateEventClick = () => {
    if (isCreateEventBlocked()) {
      setOpenModalTrue(true);
      return;
    }

    clearFields();
    setIsEdit(false);
    setCurrentId(null);
    setShowNewEvent(true);
    requestGeolocationOnCreate();
  };
  const fazendaId = Number(location.pathname.split('/')[2]);
  const effectiveFarmId = farmId || fazendaId;

  const selectAgroFarmsRef = useRef(null);
  const selectAgronomistRef = useRef(null);
  const selectProducerRef = useRef(null);
  const selectStatusRef = useRef(null);


  const isMobileDevice = () => /android|iphone|ipad|ipod|windows phone/i.test(navigator.userAgent || window.opera);
  const getMapLink = (event) => {
    const farm = event.agro_farms || {};
    const hasCoords = farm.latitude != null && farm.longitude != null && farm.latitude !== '' && farm.longitude !== '';
    const hasAddress = !!farm.endereco;
    if (!hasCoords && !hasAddress) return { href: null, disabled: true };
    const q = hasCoords ? `${farm.latitude},${farm.longitude}` : `${farm.endereco}`;
    const href = isMobileDevice() ? `geo:0,0?q=${encodeURIComponent(q)}` : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
    return { href, disabled: false };
  };

  const formatarDataParaAPI = (dataLocal) => {
    if (!dataLocal) return "";
    const date = new Date(dataLocal);
    const offset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - offset).toISOString();
  };

  const requestGeolocation = () => new Promise((resolve, reject) => {
    if (!('geolocation' in navigator)) {
      reject({ code: 'NOT_SUPPORTED' });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => resolve({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy,
      }),
      (error) => reject(error),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  });

  const tryGetGeolocation = async () => {
    try {
      const coords = await requestGeolocation();
      return coords;
    } catch (err) {
      let message = null;
      if (err?.code === 1) message = identifyErrorMenssage(err, "Permissão de localização negada. O evento será criado sem coordenadas.");
      else if (err?.code === 2) message = identifyErrorMenssage(err, "Localização indisponível no momento. O evento será criado sem coordenadas.");
      else if (err?.code === 3) message = identifyErrorMenssage(err, "Tempo esgotado ao obter localização. O evento será criado sem coordenadas.");
      else if (err?.code === 'NOT_SUPPORTED') message = identifyErrorMenssage(err, "Geolocalização não suportada neste dispositivo/navegador.");
      if (message) {
        store.addNotification({
          title: "Atenção",
          message,
          type: "warning",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true },
        });
      }
      return null;
    }
  };

  const requestGeolocationOnCreate = () => {
    tryGetGeolocation()
      .then((c) => {
        setUserCoords(c);
        if (c && c.latitude != null && c.longitude != null) {
          store.addNotification({
            title: "Localização registrada",
            message: `Coordenadas capturadas: ${typeof c.latitude === 'number' ? c.latitude.toFixed(6) : c.latitude}, ${typeof c.longitude === 'number' ? c.longitude.toFixed(6) : c.longitude}`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 4000, onScreen: true },
          });
        }
      })
      .catch(() => setUserCoords(null));
  };

  const buildMeteoblueUrl = (lat, lng) => {
    if (lat == null || lng == null) return null;
    return `https://www.meteoblue.com/en/weather/maps/widget/${lat}N${lng}E654_America%2FSao_Paulo?windAnimation=1&gust=1&satellite=1&cloudsAndPrecipitation=1&temperature=1&sunshine=1&extremeForecastIndex=1&geoloc=fixed&tempunit=C&windunit=km%252Fh&lengthunit=metric&zoom=10&autowidth=auto`;
  };

  const clearFields = () => {
    if (selectAgronomistRef.current) selectAgronomistRef.current.clearSelect();
    if (selectProducerRef.current) selectProducerRef.current.clearSelect();
    if (selectAgroFarmsRef.current) selectAgroFarmsRef.current.clearSelect();
    if (selectStatusRef.current) selectStatusRef.current.clearSelect();

    setTitleDrawer("");
    setDescriptionDrawer("");
    setAgronomistDrawer({ value: 0, label: "" });
    setProducerDrawer({ value: 0, label: "" });
    setCultureDrawer({ value: 0, label: "" });
    setAgronomistDrawer({ value: 0, label: "" });
    setProducerDrawer({ value: 0, label: "" });
    setAgroFarmsDrawer({ value: 0, label: "" });
    setCultureDrawer({ value: 0, label: "" });
    setAgroFarmIdToSelect(null);
    
    setStartDateDrawer("");
    setEndDateDrawer("");
    setStatusDrawer({ value: 0, label: "" });
    setAgroFarmsDrawer({ value: 0, label: "" });
    setAgroFarms([]);
    setIsFarmDisabled(true);

    setTitleError(false);
    setDescriptionError(false);
    setAgronomistError(false);
    setProducerError(false);
    setFarmError(false);
    setCultureError(false);
    setStartDateError(false);
    setEndDateError(false);
    setStatusError(false);
    setEventCoords(null);
  };

  const validateForm = () => {
    let isValid = true;
    if (!titleDrawer.trim()) { setTitleError(true); isValid = false; }
    if (!agronomistDrawer.value) { setAgronomistError(true); isValid = false; }
    if (!startDateDrawer) { setStartDateError(true); isValid = false; }
    if (!endDateDrawer) { setEndDateError(true); isValid = false; }
    if (!statusDrawer.value) { setStatusError(true); isValid = false; }

    if (endDateDrawer < startDateDrawer) {

      setStartDateError(true);
      setEndDateError(true);

      store.addNotification({
        title: "Erro!",
        message: "A data final deve ser maior que a data inicial!",
        type: "warning",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });

      isValid = false;
    }

    return isValid;
  };

  const handleSaveEvent = async () => {
    if (!validateForm()) {
      store.addNotification({
        title: "Erro!",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    setIsLoading(true);

    let coords = userCoords;
    let capturedNow = false;
    if (!coords) {
      coords = await tryGetGeolocation();
      if (coords) { setUserCoords(coords); capturedNow = true; }
    }
    if (capturedNow && coords && coords.latitude != null && coords.longitude != null) {
      store.addNotification({
        title: "Localização registrada",
        message: `Coordenadas capturadas: ${typeof coords.latitude === 'number' ? coords.latitude.toFixed(6) : coords.latitude}, ${typeof coords.longitude === 'number' ? coords.longitude.toFixed(6) : coords.longitude}`,
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    }

    const payload = {
      title: titleDrawer,
      agro_agronomist_id: parseInt(agronomistDrawer.value),
      agro_producer_id: parseInt(producerDrawer.value),
      agro_farm_id: parseInt(agroFarmsDrawer.value),
      description: descriptionDrawer,
      agro_culture_id: parseInt(cultureDrawer.value),
      date_begin: formatarDataParaAPI(startDateDrawer),
      date_end: formatarDataParaAPI(endDateDrawer),
      agro_task_status_id: parseInt(statusDrawer.value),
      ...(coords && coords.latitude != null && coords.longitude != null ? { latitude: String(coords.latitude), longitude: String(coords.longitude) } : {}),
    };

    try {
      const response = await api.post("/agenda", payload);
      if (response) {
        setShowNewEvent(false);
        setIsEdit(false);
        clearFields();
        getEvents();
        store.addNotification({
          title: "Sucesso!",
          message: `${response.data.message}`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true },
        });
        if (coords && coords.latitude != null && coords.longitude != null) {
          store.addNotification({
            title: "Localização registrada",
            message: `Coordenadas salvas no evento: ${String(coords.latitude)}, ${String(coords.longitude)}`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 4000, onScreen: true },
          });
        } else {
          store.addNotification({
            title: "Aviso",
            message: "Evento criado sem geolocalização.",
            type: "info",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: { duration: 4000, onScreen: true },
          });
        }
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Erro ao salvar evento';

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, errorMessage),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } finally {
      setIsLoading(false);
      getEvents();
      clearFields();
      getOptions();
    }
  };

  const getEvents = async () => {
    try {
      const response = await api.get(`/agenda/resumo/${fazendaId}`);

      if (response) {
        const reversedEvents = response.data.reverse();

        setEvents(reversedEvents);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getAgronomists = async () => {
    try {
      const res = await api.post("/agronomos/pesquisa?limit=30&offset=0", { search: "", estado: "" });
      const list = res.data.data.agronomists.map(a => ({ value: a.id, label: a.nome }));
      setAgronomists(list);
    } catch (e) {
      console.error(e);
    }
  };

  const getProducers = async () => {
    const state = {
      estado: "SP",
    };

    try {
      const response = await api.get(`/produtores/estado/${state.estado}`);

      const producersData = response.data.data.map((producer) => ({
        value: producer.id,
        label: producer.nome,
        cpf_cnpj: producer.cpf_cnpj,
        agro_farms: producer.agro_farms.map((farm) => ({
          id: farm.id,
          label: farm.nome,
          state: farm.estado,
        })),
      }));

      setProducers(producersData);

      if (producersData.length === 1) {
        setProducerDrawer({
          value: producersData[0].value,
          label: producersData[0].label,
        });
        setProducerError(false);

        getAgroFarms(producersData[0].value);
      }
    } catch (error) {
    }
  };

  const getAllProducers = async () => {
    const payload = {
      search: "",
      estado: "",
      order_by: { field: "modified", order: "DESC" }
    };

    try {
      const response = await api.post("/produtores/pesquisa?limit=30&offset=0", payload);

      const produtores = response.data.data.produtores;

      const producersData = produtores.map((producer) => ({
        value: producer.id,
        label: producer.nome,
        cpf_cnpj: producer.cpf_cnpj,
        agro_farms: producer.agro_farms.map((farm) => ({
          id: farm.id,
          label: farm.nome,
          state: farm.estado
        }))
      }));

      setProducers(producersData);

      if (producersData.length === 1) {
        const unico = producersData[0];
        setProducerDrawer({ value: unico.value, label: unico.label });
        setProducerError(false);
        // getAgroFarms(unico.value);
      }

    } catch (error) {
      console.error("Erro ao buscar produtores:", error);
    }
  };

  const getCultures = async () => {
    try {
      const res = await api.get("/culturas");
      const flat = res.data.data.flat().map(c => ({ value: c.id, label: c.nome_comum }));
      setCultures(flat);
    } catch (e) {
      console.error(e);
    }
  };

  const getAgroFarms = async (producerId) => {
    if (producerId === 0 || !producerId) return

    try {
      const response = await api.get(`/produtores/${producerId}/fazendas`);
      const farms = response.data.data.map(f => ({ value: f.id, label: f.nome }));
      setAgroFarms(farms);
      setIsFarmDisabled(false);
      if (farms.length === 1) setAgroFarmsDrawer(farms[0]);
    } catch (error) {

      setFarmError(true);

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, `Nenhuma fazenda foi encontrada para esse produtor`),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    }
  };

  const handleCultureChange = (e) => {
    setSelectedCulture(e.target.value);
    try {
      localStorage.setItem(`farmCrop:${effectiveFarmId}:culture`, e.target.value);
    } catch {}
  };

  const handleTalhaoChange = (e) => {
    setSelectedTalhao(e.target.value);
    try {
      localStorage.setItem(`farmCrop:${effectiveFarmId}:talhao`, e.target.value);
    } catch {}
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("pt-BR", { month: "short" }).replace(".", "").toUpperCase();
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  };

  useEffect(() => {
    try {
      const sc = localStorage.getItem(`farmCrop:${effectiveFarmId}:culture`);
      const st = localStorage.getItem(`farmCrop:${effectiveFarmId}:talhao`);
      if (sc) setSelectedCulture(sc);
      if (st) setSelectedTalhao(st);
    } catch {}
  }, [effectiveFarmId]);

  const getOptions = async () => {
    if (!farmId || farmId === 0) return;

    try {
      const response = await api.get(`/fazendas/${farmId}`);

      const cultures = response.data.data.cultura;
      setCulturesOptions(cultures)
      setFarmDetail(response.data.data || null);
      const data = response.data.data || {};
      const t = data.talhoes || data.talhao || data.agro_fields || data.fields || [];
      setTalhoesOptions(Array.isArray(t) ? t : []);
    } catch {

    }
  }

  const getStatusLabel = (statusId) => {
    const statusMap = {
      1: "Não iniciado",
      2: "Em progresso",
      3: "Aguardando aprovação",
      4: "Pausado",
      5: "Atrasado",
      6: "Cancelado",
      7: "Feito",
    };
    return statusMap[statusId] || "";
  };

  useEffect(() => {
    getEvents();
    getAgronomists();
    getProducers();
    getCultures();
    getAllProducers();
  }, []);

  useEffect(() => {
    getOptions();
  }, [farmId])

  useEffect(() => {
    if (producerDrawer?.value) {
      getAgroFarms(producerDrawer.value);
    }
  }, [producerDrawer?.value]);

  useEffect(() => {
    if (agroFarms.length > 0 && agroFarmIdToSelect) {
      const farm = agroFarms.find((f) => f.value === agroFarmIdToSelect);
      setAgroFarmsDrawer({ value: agroFarmIdToSelect, label: farm?.label || "" });
    }
  }, [agroFarms, agroFarmIdToSelect]);

  const isToday = (date) => {
    const today = new Date();
    const eventDate = new Date(date);

    return today.getDate() === eventDate.getDate() &&
      today.getMonth() === eventDate.getMonth() &&
      today.getFullYear() === eventDate.getFullYear();
  };

  const getEventTalhaoName = (e) => {
    return (
      e?.agro_fields?.nome ||
      e?.agro_field?.nome ||
      e?.talhao?.nome ||
      e?.agro_talhao?.nome ||
      e?.field?.nome ||
      e?.lote?.nome ||
      e?.talhao ||
      ""
    );
  };

  const containerRef = useRef();

  const handleOpenEvent = async (event, e) => {
    if (e?.target?.closest(".contact-icon")) {
      return;
    }

    setCurrentId(event.id);
    setAgronomistDrawer({ value: 0, label: "" });
    setProducerDrawer({ value: 0, label: "" });
    setAgroFarmsDrawer({ value: 0, label: "" });

    try {
      const response = await api.get(`/agenda/${event.id}`);

      setIsEdit(true);
      setShowNewEvent(true);

      const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().slice(0, 16);
      };

      setTitleDrawer(response.data.title || "");
      setDescriptionDrawer(response.data.description || "");
      setStartDateDrawer(formatDateForInput(response.data.date_begin));
      setEndDateDrawer(formatDateForInput(response.data.date_end));

      if (response.data.agro_agronomist_id) {
        try {
          const responseAgronomist = await api.get(
            `/agronomos/${response.data.agro_agronomist_id}`
          );
          const agronomist = responseAgronomist.data.data;
          setAgronomistDrawer({ value: agronomist.id, label: agronomist.nome });
          setAgronomistError(false);
        } catch { }
      }

      const producer = producers.find(
        (p) => p.value === response.data.agro_producer_id
      );
      setProducerDrawer({ value: response.data.agro_producer_id, label: producer?.label || "" });
      setIdProducer(response.data.agro_producer_id || 0);

      await getAgroFarms(response.data.agro_producer_id);
      setAgroFarmIdToSelect(response.data.agro_farm_id);

      const culture = cultures.find((c) => c.value === response.data.agro_culture_id);
      setCultureDrawer({ value: response.data.agro_culture_id, label: culture?.label || "" });

      setStatusDrawer({
        value: response.data.agro_task_status_id,
        label: getStatusLabel(response.data.agro_task_status_id),
      });

      if (response.data.latitude && response.data.longitude) {
        setEventCoords({ latitude: response.data.latitude, longitude: response.data.longitude });
      } else {
        setEventCoords(null);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Erro ao abrir evento";

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, errorMessage),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    }
  };

  const prefillDrawer = () => {
    const f = farmDetail || {};
    const prod = f.agro_producers || {};
    if (prod.id && prod.nome) {
      setProducerDrawer({ value: prod.id, label: prod.nome });
      setProducerError(false);
    }
    if (f.id && f.nome) {
      setAgroFarms([{ value: f.id, label: f.nome }]);
      setAgroFarmsDrawer({ value: f.id, label: f.nome });
      setIsFarmDisabled(false);
      setFarmError(false);
    }
    let chosen = null;
    if (events && events.length > 0) {
      const last = events[0];
      const agName = last?.agro_agronomists?.nome || last?.agro_agronomists?.label || "";
      if (agName) {
        const match = agronomists.find(a => (a.label || "").toLowerCase() === agName.toLowerCase());
        if (match) chosen = match;
      }
    }
    if (!chosen && agronomists.length === 1) {
      chosen = agronomists[0];
    }
    if (chosen && chosen.value && chosen.label) {
      setAgronomistDrawer({ value: chosen.value, label: chosen.label });
      setAgronomistError(false);
    }

    if (selectedCulture && selectedCulture.trim() !== "") {
      const norm = (s) => (s || "").normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase();
      const ctx = culturesOptions.find(c => norm(c.nome_comum) === norm(selectedCulture));
      let matchCulture = null;
      if (ctx && ctx.id) {
        matchCulture = cultures.find(c => c.value === ctx.id);
      }
      if (!matchCulture) {
        const targetName = ctx?.nome_comum || selectedCulture;
        matchCulture = cultures.find(c => norm(c.label) === norm(targetName));
      }
      if (matchCulture && matchCulture.value && matchCulture.label) {
        setCultureDrawer({ value: matchCulture.value, label: matchCulture.label });
        setCultureError(false);
      }
    }
  };

  useEffect(() => {
    if (showNewEvent) {
      prefillDrawer();
    }
  }, [showNewEvent, farmDetail, agronomists, events, cultures, selectedCulture, culturesOptions]);

  const handleEditEvent = async () => {
    if (!currentId) {
      store.addNotification({
        title: "Erro!",
        message: "Não foi possível identificar o evento para editar",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    if (!validateForm()) {
      store.addNotification({
        title: "Erro!",
        message: "Preencha todos os campos obrigatórios",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
      return;
    }

    setIsLoading(true);
    const payload = {
      title: titleDrawer,
      agro_agronomist_id: agronomistDrawer?.value ? parseInt(agronomistDrawer.value) : null,
      agro_producer_id: producerDrawer?.value ? parseInt(producerDrawer.value) : null,
      agro_farm_id: agroFarmsDrawer?.value ? parseInt(agroFarmsDrawer.value) : null,
      description: descriptionDrawer,
      agro_culture_id: cultureDrawer?.value ? parseInt(cultureDrawer.value) : null,
      date_begin: formatarDataParaAPI(startDateDrawer),
      date_end: formatarDataParaAPI(endDateDrawer),
      agro_task_status_id: parseInt(statusDrawer.value),
    };

    try {
      const response = await api.put(`/agenda/${currentId}`, payload);

      if (response) {
        setShowNewEvent(false);
        setIsEdit(false);
        setCurrentId(null);
        clearFields();
        getEvents();

        store.addNotification({
          title: "Sucesso!",
          message: `${response.data.message}`,
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: { duration: 4000, onScreen: true },
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Erro ao salvar evento";

      store.addNotification({
        title: "Erro!",
        message: identifyErrorMenssage(error, errorMessage),
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: { duration: 4000, onScreen: true },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const deleteEvent = async () => {
      try {
        const response = await api.delete(`/agenda/${currentId}`);
  
        if (response) {
          setShowNewEvent(false);
          setIsEdit(false);
  
          store.addNotification({
            title: "Sucesso!",
            message: `${response.data.message}`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 4000,
              onScreen: true,
            },
          });
  
          getEvents();
          clearFields();
        }
      } catch (error) {
        store.addNotification({
          title: "Erro!",
          message: identifyErrorMenssage(error),
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 4000,
            onScreen: true,
          },
        });
      }
    };

  return (
    <S.Container className='cropManagement'>
      <S.Header>
        <BodyG color={theme.colors.gray.Cinza_2} fontWeight={700}>
          Caderno de campo
        </BodyG>

        <S.CultureSelector value={selectedCulture} onChange={handleCultureChange}>
          <option value="">TODOS</option>
          {culturesOptions.map(culture => (
            <option key={culture.id} value={culture.nome_comum.toLowerCase()}>{culture.nome_comum}</option>
          ))}
        </S.CultureSelector>

      </S.Header>

      <S.ScrollArea notFound={events.length === 0}>
        <S.EventCardWrapper>
          {/* <S.VerticalText>
            <TaglineG color={theme.colors.gray.Cinza_2}>V3: Terceiro nó</TaglineG>
            <TaglineG color={theme.colors.gray.Cinza_2}>V2: Segundo nó</TaglineG>
            <TaglineG color={theme.colors.gray.Cinza_2}>V1: Primeiro nó</TaglineG>
          </S.VerticalText> */}

          <S.CardsWrapper>
            {events
              .filter(event => {
                if (!selectedCulture) return true;
                return event.agro_cultures?.nome_comum?.toLowerCase() === selectedCulture?.toLowerCase();
              })
              .filter(event => {
                if (!selectedTalhao) return true;
                const n = (getEventTalhaoName(event) || "").toLowerCase();
                return n === selectedTalhao.toLowerCase();
              })
              .map((event) => (
                <S.EventCard key={event.id} onClick={(e) => handleOpenEvent(event, e)} ref={containerRef}>
                  <S.EventInfo>
                    <BodyM color={theme.colors.gray.Cinza_2} fontWeight={700}>
                      {event.title}
                    </BodyM>
                  </S.EventInfo>

                  <S.EventActions>
                    <TaglineP color={isToday(event.date_begin) ? `${theme.colors.orange.Laranja}` : theme.colors.gray.Cinza_7}>
                      {formatDate(event.date_begin)}
                    </TaglineP>

                    <S.CropBadge>
                      <S.Bullet />
                      <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
                        {event.agro_task_status?.descricao === "Aguardando aprovação" ? "Aguardando Ap..." : event.agro_task_status?.descricao}
                      </TaglineP>
                    </S.CropBadge>
                  </S.EventActions>
                </S.EventCard>
              ))}

              {events.length === 0 && (
                <S.NotFound>
                  <img src={IconSearchNotFound} alt="Ícone de pesquisa" />

                  <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                      Nenhum evento encontrado
                  </TaglineM>
                </S.NotFound>
              )}
          </S.CardsWrapper>
        </S.EventCardWrapper>
      </S.ScrollArea>

      <S.CreateEventButton onClick={handleCreateEventClick}>
        <S.PlusIcon src={plus} />
        <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>
          CRIAR EVENTO
        </TaglineM>
      </S.CreateEventButton>

      <ModalCreateOrEditEvent
        open={showNewEvent}
        onOpenChange={(e) => {
          setShowNewEvent(e);
          if (!e) {
            clearFields();
            setIsEdit(false);
            setCurrentId(null);
          }
        }}
        isEdit={isEdit}
        styles={S}
        updateDelete={() => {
          deleteEvent();
        }}
        responsavelTecnicoValue={agronomistDrawer.value ? agronomistDrawer.value : ""}
        onResponsavelTecnicoChange={(selectedOption) => {
          setAgronomistDrawer({
            value: selectedOption.value,
            label: selectedOption.label,
          });
          setAgronomistError(false);
        }}
        agronomists={agronomists}
        agronomistError={agronomistError}
        onAddAgronomist={() => setShowAddAgronomist(true)}
        produtorValue={producerDrawer.value ? producerDrawer.value : ""}
        onProdutorChange={(selectedOption) => {
          setProducerDrawer({
            value: selectedOption.value,
            label: selectedOption.label,
          });
          setIdProducer(selectedOption.value);
          setAgroFarmsDrawer({});
          getAgroFarms(selectedOption.value);
          setProducerError(false);
        }}
        producers={producers}
        producerError={producerError}
        onAddProducer={() => setShowAddProducer(true)}
        fazendaValue={agroFarmsDrawer.value ? agroFarmsDrawer.value : ""}
        onFazendaChange={(selectedOption) => {
          setAgroFarmsDrawer({
            value: selectedOption.value,
            label: selectedOption.label,
          });
          setFarmError(false);
        }}
        agroFarms={agroFarms}
        farmError={farmError}
        isFarmDisabled={isFarmDisabled}
        isButtonFarmDisabled={false}
        onAddFarm={() => setShowAddFarm(true)}
        titleValue={titleDrawer}
        onTitleChange={(e) => {
          setTitleDrawer(e.target.value);
          if (e.target.value.trim()) setTitleError(false);
        }}
        titleError={titleError}
        descriptionValue={descriptionDrawer}
        onDescriptionChange={(e) => {
          setDescriptionDrawer(e.target.value);
          if (e.target.value.trim()) setDescriptionError(false);
        }}
        descriptionError={descriptionError}
        culturaValue={cultureDrawer?.value ? cultureDrawer.value : ""}
        onCulturaChange={(selectedOption) => {
          setCultureDrawer({
            value: selectedOption.value,
            label: selectedOption.label,
          });
          setCultureError(false);
        }}
        cultures={cultures}
        cultureError={cultureError}
        startDateValue={startDateDrawer}
        onStartDateChange={(e) => {
          setStartDateDrawer(e.target.value);
          if (e.target.value) setStartDateError(false);
        }}
        startDateError={startDateError}
        endDateValue={endDateDrawer}
        onEndDateChange={(e) => {
          setEndDateDrawer(e.target.value);
          if (e.target.value) setEndDateError(false);
        }}
        endDateError={endDateError}
        statusRef={selectStatusRef}
        statusValue={statusDrawer.value ? statusDrawer : null}
        onStatusChange={(selectedOption) => {
          setStatusDrawer({
            value: selectedOption.value,
            label: selectedOption.label,
          });
          setStatusError(false);
        }}
        statusError={statusError}
        statusFloatingValue={statusDrawer.label}
        mapCoords={eventCoords}
        buildMapUrl={buildMeteoblueUrl}
        commentResourceId={isEdit ? currentId : 0}
        onSave={isEdit ? handleEditEvent : handleSaveEvent}
        isLoading={isLoading}
      />
      {showAddAgronomist && (
        <Modal show={showAddAgronomist} title="Cadastrar novo responsável técnico" onHide={() => setShowAddAgronomist(false)}>
          <RegisterAgronomist
            onSuccess={() => {
              getAgronomists();
              setShowAddAgronomist(false);
            }}
            onCancel={() => setShowAddAgronomist(false)}
          />
        </Modal>
      )}

      {showAddProducer && (
        <Modal show={showAddProducer} title="Cadastrar novo produtor" onHide={() => setShowAddProducer(false)}>
          <RegisterProducer
            onSuccess={() => {
              getProducers();
              setShowAddProducer(false);
            }}
            onCancel={() => setShowAddProducer(false)}
          />
        </Modal>
      )}

      {showAddFarm && (
        <Modal show={showAddFarm} title="Cadastrar nova fazenda" onHide={() => setShowAddFarm(false)}>
          <RegisterFarm
            producerId={idProducer}
            onSuccess={() => {
              getAgroFarms(idProducer);
              setShowAddFarm(false);
            }}
            onCancel={() => setShowAddFarm(false)}
          />
        </Modal>
      )}

      {openModalTrue ? (
        <ModalBlock show={openModalTrue} onHide={() => setOpenModalTrue(false)} />
      ) : null}
    </S.Container>
  );
};

export default FarmCropManagement;